// docx-parser.js — mammoth.js 动态加载 + docx 解析
// 用于 /list 和 /story 两端共享：list 端预解析，story 端回退重解析

// 动态加载 mammoth.js（UMD bundle，挂载到 window.mammoth）
export function loadMammoth() {
  return new Promise(function(resolve, reject) {
    if (window.mammoth) { resolve(window.mammoth); return; }
    var script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/mammoth@1.8.0/mammoth.browser.min.js';
    script.onload = function() { resolve(window.mammoth); };
    script.onerror = function() { reject(new Error('mammoth load failed')); };
    // 10 秒超时
    var timeout = setTimeout(function() {
      script.remove();
      reject(new Error('mammoth load timeout'));
    }, 10000);
    script.addEventListener('load', function() { clearTimeout(timeout); });
    document.head.appendChild(script);
  });
}

// 解析 docx 文件为 markdown
// file: File 对象（来自 File System Access API 或 <input>）
// 返回 { content: string }，解析失败抛出异常
export async function parseDocxToMarkdown(file) {
  var mammoth = await loadMammoth();
  var result = await mammoth.convertToMarkdown({ arrayBuffer: await file.arrayBuffer() });
  return {
    content: result.value,
    warnings: result.messages || []
  };
}
